import { Controller } from "@hotwired/stimulus"
import L from "leaflet"
// import * as protomapsL from "protomaps-leaflet"

// Connects to data-controller="map"
export default class extends Controller {
  static targets = ["mapcontainer"]
  // static outlets = ["latlon"]
  static values = { latlon: Array, url: {type: String}, locality: String, language: String, geoip: String, geolocation: Array, draggable: String }
  static newSrc = ""
  static loaded = false
  static disableRefresh = false
  static markers = []
  static outlets = ["filters", "cookieconsent"]
  cookieconsentCategory = "necessary"

  connect() {
    if (!this.hasCookieconsentOutlet) {
      this.setup()
    }
    else if (this.cookieconsentOutlet.acceptedCategory(this.cookieconsentCategory)) {
      this.setup()
    }
    else {
      window.addEventListener('cc:onConsent', (({detail}) => {
        if (detail.cookie.categories.includes(this.cookieconsentCategory)) {
          this.setup()
        }
      }).bind(this))
    }
  }

  setup() {
    L.Icon.Default.mergeOptions({
      iconUrl: RAILS_ASSET_URL('leaflet/images/marker-icon.png'),
      iconRetinaUrl: RAILS_ASSET_URL('leaflet/images/marker-icon-2x.png'),
      shadowUrl: RAILS_ASSET_URL('leaflet/images/marker-shadow.png')
    })
    this.createMap()
    if (this.geolocationValue && this.geolocationValue.length > 0) {
      this.map.setView(this.geolocationValue, 8)
    } else {
      this.map.fitBounds(this.latlonValue.map(([id, title, v]) => v))
    }
    if (this.localityValue == "locality") {
      this.map.setZoom(11)
    } else if (this.localityValue == "marker") {
      this.map.setZoom(12)
    }
    this.markers = []
    this.addMarkers(this.latlonValue)
    if (!!this.draggableValue) {
      document.getElementById('modal-map-coordinates')
        .addEventListener('shown.bs.modal', function() {
        this.map.invalidateSize()
      }.bind(this))
    }
    // this.map.setView([50.3384603,4.2801356], 15.91)

    // document.documentElement.addEventListener('turbo:frame-load', function (e) {
    //   console.log(e)
    // })
    // document.documentElement.addEventListener('search_load', function (e) {
    //   console.log(e)
    // })
  }

  addMarkers(latlonValue) {
    const grouped = {}
    for (const v of latlonValue) {
      const [id, title, [latitude, longitude]] = v
      const k = `${latitude}_${longitude}`
      if (!grouped.hasOwnProperty(k)) {
        grouped[k] = []
      }
      grouped[k].push([id, title, [latitude, longitude]])
    }
    // console.log(grouped)
    for (const k in grouped) {
      this.addGroupedMarker(grouped[k])
    }

    // latlonValue.forEach((function(v) { this.addMarker(v) }).bind(this))
  }

  updateMarkers(latlonValue) {
    // remove markers
    if (this.markers) {
      this.markers.forEach((function(v) { this.map.removeLayer(v) }).bind(this))
    }
    if (this.map) {
      this.addMarkers(latlonValue)
      // latlonValue.forEach((function(v) { this.addMarker(v) }).bind(this))
    }
  }

  updateFilters(filters) {
    // console.log(filters)
    this.filters = filters
    this.updateUrl(0)
  }

  updateUrl(delay = 500) {
    const frame = document.getElementById("vending_machines")
    const bounds = this.map.getBounds()
    const bounds_list = [
      bounds._northEast['lng'],
      bounds._northEast['lat'],
      bounds._southWest['lng'],
      bounds._southWest['lat']
    ]
    // const src = searchUrl + "?search_form[bounds]=" + bounds_list.join(",")
    const boundsQuery = "&search_form[bounds]=" + bounds_list.join(",")
    const filters = this.hasFiltersOutlet ? this.filtersOutlet.getFilters() : []
    const filtersQuery = filters.map((v) => `&search_form[filters][]=${v}`).join("")
    // console.log(filtersQuery)
    const src = this.urlValue + boundsQuery + filtersQuery
    this.newSrc = src

    if (this.pending_timeout) {
      clearTimeout(this.pending_timeout)
    }

    this.pending_timeout = setTimeout(() => {
      if (frame && frame.src != this.newSrc) {
        frame.src = this.newSrc
        // console.log(src)
      }
    }, delay)
  }

  createMap() {
    this.map = L.map(this.mapcontainerTarget, {
      // attributionControl: false
    })

    // const minZoom = this.localityValue == "locality" ? 11 : 8
    // const minZoom = 11
    const minZoom = 8

    const geoipPrefix = (this.geoipValue == "db-ip") ? ' | <a href="https://db-ip.com" title="IP Geolocation by DB-IP">DB-IP</a>' : ''
    this.map.attributionControl.setPrefix('<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>' + geoipPrefix)

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      minZoom: minZoom,
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'
    }).addTo(this.map)

    // var layer = protomapsL.leafletLayer({
    //   url: "http://tpc.local:8000/test/{z}/{x}/{y}.mvt",
    //   minZoom: minZoom,
    //   maxZoom: 19,
    //   flavor: "light",
    //   lang: this.languageValue
    // })
    // layer.addTo(this.map)

    const map = this.map
    const searchUrl = this.urlValue
    const that = this

    this.map.on('load', function() {
      // that.loaded = true
      setTimeout(() => {
        that.loaded = true
      }, 1000)
    })

    this.map.on('popupopen', function() {
      that.disableRefresh = true;
    })

    this.map.on('dragstart', function() {
      that.disableRefresh = false;
    })

    this.map.on('zoomstart', function() {
      that.disableRefresh = false;
    })

    this.map.on('dragend', function() {
      if (!that.loaded) return
      if (that.disableRefresh) return

      that.updateUrl()
    })

    this.map.on('zoomend', function() {
      if (!that.loaded) return
      if (that.disableRefresh) return

      that.updateUrl()
    })

    // this.map.on('moveend', function() {
    //   if (!that.loaded) return
    //   if (that.disableRefresh) return

    //   that.updateUrl()
    //   // const frame = document.getElementById("vending_machines")
    //   // const bounds = map.getBounds()
    //   // const bounds_list = [
    //   //   bounds._northEast['lng'],
    //   //   bounds._northEast['lat'],
    //   //   bounds._southWest['lng'],
    //   //   bounds._southWest['lat']
    //   // ]
    //   // // const src = searchUrl + "?search_form[bounds]=" + bounds_list.join(",")
    //   // const src = searchUrl + "&search_form[bounds]=" + bounds_list.join(",")
    //   // that.newSrc = src

    //   // if (this.pending_timeout) {
    //   //   clearTimeout(this.pending_timeout)
    //   // }

    //   // this.pending_timeout = setTimeout(() => {
    //   //   if (frame && frame.src != that.newSrc) {
    //   //     frame.src = that.newSrc
    //   //     // console.log(src)
    //   //   }
    //   // }, 500)

    //   // frame.src = src
    //   // console.log(src)
    // })
  }

  addMarker(v) {
    const [id, title, [latitude, longitude]] = v

    const toggleActive = function(elt, close=true) {
      if (close) {
        elt.classList.remove("bg-active-search");
        elt.classList.add("bg-light");
      } else {
        elt.classList.remove("bg-light");
        elt.classList.add("bg-active-search");
      }
    }
    const clearSelection = function() {
      const container = document.getElementById("container_vending_machines");
      if (container) {
        const cards = container.children;
        for (var i = 0; i < cards.length; i++) {
          const elt = cards[i].children[0];
          toggleActive(elt);
        }
      }
    }
    const getLink = function() {
      const elt = document.getElementById(`vending_machine_${id}`);
      if (elt) {
        const selector = elt.querySelector('a');
        if (selector) {
          return `<a href="${selector.href}">${title}</a>`
        }
      }
      return `${title}`;
    }
    const scrollInto = function(elt) {
      const boundingRect = elt.getBoundingClientRect();

      if (boundingRect.top < 0 || boundingRect.bottom > window.innerHeight) {
        elt.scrollIntoView();
      }
    }

    const that = this
    var marker = L.marker([latitude, longitude], {
      draggable: !!this.draggableValue
    })
          .addTo(this.map)
          .bindPopup(`<div>${getLink()}</div>`)
          .on('popupopen', function() {
            clearSelection();
            const elt = document.getElementById(`vending_machine_${id}`);
            if (elt) {
              toggleActive(elt, false);
              scrollInto(elt);
            }
          })
          .on('popupclose', function() {
            clearSelection();
          })

    if (!!this.draggableValue) {
      marker = marker.on('dragend', function(e) {
        document.getElementById(this.draggableValue).removeAttribute("disabled")
        const geo = e.target.toGeoJSON().geometry.coordinates
        document.getElementById(this.draggableValue).setAttribute("value", `${geo[1]},${geo[0]}`)
      }.bind(this))
    }

    this.markers.push(marker)
  }

  addGroupedMarker(grouped) {
    // const [id, title, [latitude, longitude]] = v

    const toggleActive = function(elt, close=true) {
      if (close) {
        elt.classList.remove("bg-active-search");
        elt.classList.add("bg-light");
      } else {
        elt.classList.remove("bg-light");
        elt.classList.add("bg-active-search");
      }
    }
    const clearSelection = function() {
      const container = document.getElementById("container_vending_machines");
      if (container) {
        const cards = container.children;
        for (var i = 0; i < cards.length; i++) {
          const elt = cards[i].children[0];
          toggleActive(elt);
        }
      }
    }
    const getLink = function(id, title) {
      const elt = document.getElementById(`vending_machine_${id}`);
      if (elt) {
        const selector = elt.querySelector('a');
        if (selector) {
          return `<a href="${selector.href}">${title}</a>`
        }
      }
      return `${title}`;
    }
    const scrollInto = function(elt) {
      const boundingRect = elt.getBoundingClientRect();

      if (boundingRect.top < 0 || boundingRect.bottom > window.innerHeight) {
        elt.scrollIntoView();
      }
    }

    var bubble = ""
    const eltIds = []
    console.log(grouped)
    for (const v of grouped) {
      const [id, title, _] = v
      bubble += `<div style="padding-bottom: 2px">${getLink(id, title)}</div>`
      eltIds.push(id)
    }
    const [latitude, longitude] = grouped[0][2]

    const that = this
    var marker = L.marker([latitude, longitude], {
      draggable: !!this.draggableValue
    })
          .addTo(this.map)
          .bindPopup(bubble)
          .on('popupopen', function() {
            clearSelection();
            for (const id of eltIds) {
              const elt = document.getElementById(`vending_machine_${id}`);
              if (elt) {
                toggleActive(elt, false);
                scrollInto(elt);
              }
            }
          })
          .on('popupclose', function() {
            clearSelection();
          })

    if (!!this.draggableValue) {
      marker = marker.on('dragend', function(e) {
        document.getElementById(this.draggableValue).removeAttribute("disabled")
        const geo = e.target.toGeoJSON().geometry.coordinates
        document.getElementById(this.draggableValue).setAttribute("value", `${geo[1]},${geo[0]}`)
      }.bind(this))
    }

    this.markers.push(marker)
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
    }
  }
}
